import { admins } from 'database';

import { createSelectSchema } from "drizzle-zod";
import { z } from "zod";

export const AdminModel = createSelectSchema(admins);
export type AdminModel = z.infer<typeof AdminModel>;
